import React, { useEffect, useState } from "react";
import { BootstrapModal } from "../BootstrapModal/Modal";
import { CgClose } from "react-icons/cg";
import Button from "../Button/Button";
import Typogaphy from "../Typography/Typography";
import { useDeleteMeetingSummary } from "../../hooks/useManagement";
import { useDeleteMergeItem } from "../../hooks/useCrm";

export const DeleteMergeItemModal = ({ show, handleClose, item }) => {
  const [button] = useState(false);
  const [form, setForm] = useState({ IdMergeFile: null });
  const { mutateAsync: deleteMergeItem } = useDeleteMergeItem();
  const handleDelete = async (data) => {
    await deleteMergeItem(data);
  };
  useEffect(() => {
    setForm({ IdMergeFile: item?.IdMergeFile });
  }, [item]);

  return (
    <BootstrapModal
      modaltitle="حذف پرونده ادغام شده"
      handleClose={handleClose}
      show={show}
      moreButton={button}
      size="md"
      closebutton={
        <Button style={{ width: "40px", border: "none" }} onclick={handleClose}>
          <CgClose />
        </Button>
      }
    >
      <div className="row">
        <div className="col-12">
          <Typogaphy size="15px">
            آیا از حذف پرونده ادغام شده مطمئن هستید؟
          </Typogaphy>
        </div>
        <div className="col-6 mt-2">
          <Button
            bgColor="#009ef7"
            color="#fff"
            onclick={() => {
              handleDelete(form);
              handleClose();
            }}
          >
            بله
          </Button>
        </div>
        <div className="col-6 mt-2">
          <Button bgColor="#f1416c" color="#fff" onclick={handleClose}>
            خیر
          </Button>
        </div>
      </div>
    </BootstrapModal>
  );
};
